<div class="open-header padding-vertical-small" [ngClass]="{ 'sticky': isLandingPage, 'ahm-header': isAhmLandingPage }">
  <div class="grid grid-wrapper grid-elastic grid-spill">

    <div class="open-title cell cell-large-col-span-6 cell-medium-col-span-4 cell-small-col-span-3 cell-tiny-col-span-2 flex flex-items-center">
      <div>
        <a href="{{ getReturnURL() }}" *ngIf="partnerBrandService.data.partner.redirectBack">
          <open-svg-logo name="open" class="flex flex-items-center openblue small" *ngIf="showOpenLogo(true)"></open-svg-logo>
          <div class="partner-logo" *ngIf="showOpenLogo(false)">
            <img [src]="apiEndpoint + '/media/' + partnerBrandService.data.brand.brand?.logoLarge" />
          </div>
        </a>
        <ng-container *ngIf="!partnerBrandService.data.partner.redirectBack">
          <open-svg-logo name="open" class="flex flex-items-center openblue small" *ngIf="showOpenLogo(true)"></open-svg-logo>
          <div class="partner-logo" *ngIf="showOpenLogo(false)">
            <img [src]="apiEndpoint + '/media/' + partnerBrandService.data.brand.brand?.logoLarge" />
          </div>
        </ng-container>
      </div>
    </div>

    <div class="open-header-help cell cell-large-col-span-6 cell-medium-col-span-4 cell-small-col-span-3 cell-tiny-col-span-2 flex flex-items-center">
      <div class="open-header-help-submenu flex flex-justify-end flex-items-center">
        <div *ngIf="!isSupportLinkHidden">
          <button mat-stroked-button color="secondary" class="xsmall" *ngIf="!isLandingPage && partnerName" (click)="startSupport()">
            <span *ngIf="!(intercom?.intercomAppId)">Get Support</span>
            <div *ngIf="intercom?.intercomAppId && unreadCount < 1" class="button-content">
              <mat-icon class="chat material-icons-outlined xsmall"></mat-icon>
              <span>Chat with us</span>
            </div>
            <div *ngIf="intercom?.intercomAppId && unreadCount > 0" class="unread-count-container">
              <span class="unread-count" [innerHTML]="unreadCount"></span>
              <span>New message</span>
              <span *ngIf="unreadCount > 1">s</span>
            </div>
          </button>
          <!-- Refer landing page -->
          <button mat-flat-button color="primary" type="button" *ngIf="isLandingPage" [routerLink]="['/quote/' + uuid]">Continue quote</button>
        </div>

        <app-user-menu></app-user-menu>
      </div>
    </div>

  </div>
</div>
